pageId = 'teams-portfolios-show'

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  $('#nav-dashboard').addClass 'active'
